import { render, staticRenderFns } from "./new-store.vue?vue&type=template&id=1238ae7c&"
import script from "./new-store.vue?vue&type=script&lang=js&"
export * from "./new-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports